<app-common-header></app-common-header>
<main role="main" class="maincnt">
  <div class="getbannersect sectppad pb-2 mt-1">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0">
        <div class="col-12 text-center webview"> <img src="assets/images/signimg.jpg" class="signimg signimgg" /></div>
        <div class="col-sm-12 p-0 margntp">
          <h1 class="text-center success mt-5 mbtoppad">Success!</h1>
          <h1 class="text-center recommd">Your Honest Recommendation is Ready!</h1>
          <div class="text-center mt-4 mb-4"><img src="assets/images/success.png" /></div>
          <div class="col-sm-12 p-0 text-center">
            <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
              <img src="assets/images/flash.png" class="mb-1" />
              <p class="text-center tiphead">TIP OF THE DAY</p>
              <p class="text-center tipmes">Create an account to save your responses.<br /> You will
                be able to access your Honest <br />Recommendation for the next 48 hours. Act now!</p>
            </div>
            <a class="btn mr-2 sectbtn col-md-5 col-lg-3 mt-4 font22 text-uppercase" href="javascript:void(0)" routerLink="/signupoption">CREATE
              YOUR ACCOUNT</a>
          </div>
          <p class="text-center mt-3 termtxt">By signing up you agree with the <a href="javascript:void(0)">Terms of Service</a>
            and the <a href="javascript:void(0)">Privacy Policy</a></p>
        </div>
      </div>
    </div>
  </div>
</main>